import React, {useEffect} from 'react';
import styled from "styled-components";
import WordList from '../../../components/atoms/List/WordList';
import {DetailBox, GuideBox, TitleBox} from '../../../components/atoms/Box';
import NextButton from '../../../components/atoms/Button/NextButton';
import resultInfo from "../../../data/resultInfo";
import {withRouter} from "react-router-dom";
import {inject, observer} from "mobx-react";

const ResultTemplate = inject("ResultStore")(observer((props) => {
    const type = props.match.params.type;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Wrap type={resultInfo.type[type].type}>
            <GuideBox order="1"/>
            <div className="type_box">
                <p>나의 검사결과는</p>
                <p className="second">
                    <span className="special">:</span>
                    <span className="highlight">{resultInfo.type[type].name}</span>
                    <span>{`( = 사랑에 빠진 ${resultInfo.type[type].nick})`}</span>
                </p>
            </div>
            <div className="img_box">
                {
                    resultInfo.type[type].image === 'avoid' ? (
                        <img src={require(`../../../style/img/avoid.png`)} alt="동물"/>
                    ) : (
                        <img src={require(`../../../style/img/problem.png`)} alt="동물"/>
                    )
                }
            </div>

            <TitleBox emphasis={resultInfo.type[type].name} text="이 자주 쓰는 말" sty="39.5px"
                      type={resultInfo.type[type].type}/>

            <WordList sty="24px" list={resultInfo.main_results[resultInfo.type[type].type].favorites}/>

            <TitleBox emphasis={resultInfo.type[type].name} text="의 특징" sty="39.5px" type={resultInfo.type[type].type}/>

            <DetailBox sty="28px" result={resultInfo.main_results[resultInfo.type[type].type].features}/>

            <NextButton
                clickHandler={() => props.ResultStore.setIsResult(false)}
                text="다음 페이지로 이동"
                bg="#262626"
                lineColor="#fff"
                color="#fff"
                sty="64px"
            />
        </Wrap>
    );
}));

const Wrap = styled.div`
    margin: 0 auto;
    width: 88%;
    padding-bottom: 65px;
    
    .type_box{
        margin-top: 33.4px;

        p {
            font-size: 39px;
            font-weight: bold;
            line-height: 48px;
        }

        span{
            font-size: 15px;
            font-weight: 500;
            color: #999999;
            letter-spacing: 1px;
            &.special {
                color: #000;
                font-size: 39px;
                font-weight: bold;
                line-height: 48px;
                margin-right: 5px;
            }

            &.highlight {
                color: ${props => props.type === 0 ? '#ff402c' : '#0662df'};
                font-size: 39px;
                font-weight: bold;
                line-height: 48px;
                margin-right: 5px;
            }
        }
    }

    .img_box {
        margin-top: 10px;

        img {
            width: 100%;
        }
    }
`;

export default withRouter(ResultTemplate);
